import { ProductReviewGallerySlider, ProductReviewGallerySliderProps } from './ProductReviewGallerySlider'

export default ProductReviewGallerySlider

export { type ProductReviewGallerySliderProps, ProductReviewGallerySlider }
